module.exports = __webpack_public_path__ + "static/media/approved.93341024.webp";